window.$ = window.jQuery = require('jquery');
Popper = require('popper.js');
require('bootstrap');
require('./sly');

(function (b, c) {
    var $ = b.jQuery || b.Cowboy || (b.Cowboy = {}), a;
    $.throttle = a = function (e, f, j, i) {
        var h, d = 0;
        if (typeof f !== 'boolean') {
            i = j;
            j = f;
            f = c
        }

        function g() {
            var o = this, m = +new Date() - d, n = arguments;

            function l() {
                d = +new Date();
                j.apply(o, n)
            }

            function k() {
                h = c
            }

            if (i && !h) {
                l()
            }
            h && clearTimeout(h);
            if (i === c && m > e) {
                l()
            }
            else {
                if (f !== true) {
                    h = setTimeout(i ? k : l, i === c ? e - m : e)
                }
            }
        }

        if ($.guid) {
            g.guid = j.guid = j.guid || $.guid++
        }
        return g
    };
    $.debounce = function (d, e, f) {
        return f === c ? a(d, e, false) : a(d, f, e !== false)
    }
})(window);

$(document).ready(function () {
    $('button.navbar-toggler').on('click', function () {
        var $toogler = $('button.navbar-toggler');
        var isCollapsed = $toogler.is('.collapsed');
        $toogler.toggleClass('icon-menu2', !isCollapsed).toggleClass('icon-cross22', isCollapsed);
    });

    $('form input, form textarea, form select').each(function () {
        if ($(this).val().length > 0) {
            $(this).parent().addClass('active');
        }
    });

    $(document)
        .on('focus', 'form input, form textarea, form select', function () {
            $(this).parent().addClass('active');
        })
        .on('blur', 'form input, form textarea, form select', function () {
            if ($(this).val().length === 0) {
                $(this).parent().removeClass('active');
            }
        });

    var $frame = $('.frame');


    if (window.innerWidth >= 767) {
        $frame.sly('destroy');
        $('.frame').removeClass('frame');
    }
    else {
        $frame.sly({
            horizontal: 1,
            itemNav: 'forceCentered',
            smart: 1,
            activateMiddle: 1,
            mouseDragging: 1,
            touchDragging: 1,
            releaseSwing: 1,
            startAt: 0,
            speed: 300,
            elasticBounds: 1,
            activatePageOn: 'click',
            dragHandle: 1,
            dynamicHandle: 1,
            clickBar: 1,
            pagesBar: $('.slider-pages'),
            cycleBy: 'items',
            cycleInterval: 3500,
            pauseOnHover: true,
            auto: false,
            prev: $('.prev'),
            next: $('.next')
        });
    }

    $frame.sly('reload');

    $(window).resize($.debounce(250, function (e) {
        if (window.innerWidth >= 767) {
            $frame.sly('destroy');
            $('.frame').removeClass('frame');
        }
        else {
            $('.slider-list').addClass('frame');
            $frame.sly({
                horizontal: 1,
                itemNav: 'forceCentered',
                smart: 1,
                activateMiddle: 1,
                mouseDragging: 1,
                touchDragging: 1,
                releaseSwing: 1,
                startAt: 0,
                speed: 300,
                elasticBounds: 1,
                activatePageOn: 'click',
                dragHandle: 1,
                dynamicHandle: 1,
                clickBar: 1,
                pagesBar: $('.slider-pages'),
                cycleBy: 'items',
                cycleInterval: 3500,
                pauseOnHover: true,
                auto: false,
                prev: $('.prev'),
                next: $('.next')
            });
        }

        $frame.sly('reload');
    }));

    var $frameImg = $('.frame-img');
    $frameImg.sly({
        horizontal: 1,
        itemNav: 'forceCentered',
        smart: 1,
        activateMiddle: 1,
        mouseDragging: 1,
        touchDragging: 1,
        releaseSwing: 1,
        startAt: 0,
        speed: 300,
        elasticBounds: 1,
        activatePageOn: 'click',
        dragHandle: 1,
        dynamicHandle: 1,
        clickBar: 1,
        pagesBar: $('.slider-pages-img'),
        cycleBy: 'items',
        cycleInterval: 3500,
        pauseOnHover: true,
        auto: false,
    });


    $('#submittedfile').on('change', function(e) {
        if (e.currentTarget.value.length > 0) {
            if ($('.cibling-val').length > 0) {
                $('.cibling-val').remove('.cibling-val');
            }

            var val = e.currentTarget.value.replace(/^.*[\\\/]/, '');

            var ciblingP = $("<p class='cibling-val'>" + val + '</p>')

            $('.file ').append(ciblingP);
        }
    })
});


// WEBPACK FOOTER //
// ./webroot/src/js/main.js